const query = (id, isPreview) => `{
  roundBrandTilesWithFilter(id: "${id}", preview: ${isPreview}) {
    categoriesCollection(limit: 10) {
      items {
        id
        label
        name
      }
    }
    filterLabel
    brandsCollection {
      items {
        category {
          id
        }
        title
        svgColor
        image {
          altText
          imageMobile {
            title
            description
            url
            width
            height
          }
          imageDesktop {
            title
            description
            url
            width
            height
          }
        }
        link {
          label
          title
          url
          target
          scrollToElementId
          gaEventClass
          gaEventLabel
          ariaLabel
        }
      }
    }
  }
}
`

module.exports = { query }
